// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__11kAQ","numberPhone":"styles_numberPhone__1C1Ii"};